
namespace SorAraBul.Definitions {
    export class PetsColumns {
        static columnsKey = 'Definitions.Pets';
    }
}